import React from 'react'
import styled from '@emotion/styled'
import { CheckMark } from '@jelly/components'
import { array } from 'prop-types'

const StatsBarWrapper = styled.div`
	align-items: flex-start;
	background-color: ${({ theme }) => theme.colors.gray[700]};
	color: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	height: auto;
	padding: 3rem 1rem;
	width: 100%;
`
const FlexContainer = styled.div`
	${({ theme }) => theme.maxWidth.L};
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		flex-direction: row;
		flex-wrap: wrap;
	}

	${({ theme }) => theme.MQ.L} {
		flex-wrap: nowrap;
		margin: auto;
	}
`
const FlexRow = styled.div`
	align-items: center;
	display: flex;
	justify-content: flex-start;
	height: 3.375rem; /* 54px - same as checkmark */
	margin: 1rem 0;

	${({ theme }) => theme.MQ.M} {
		flex: 0 0 40%;
		justify-content: center;
		margin: 1rem auto;
	}

	${({ theme }) => theme.MQ.L} {
		flex: initial;
		width: 25%;
	}
`
const Stat = styled.div`
	${({ theme }) => theme.fonts.primarySemiBold};
	font-size: 1.125rem;
	letter-spacing: 1px;
	line-height: 27px;
	margin: 0 1rem 0 0.75rem;
	width: 100%;
`
StatsBar.propTypes = {
	stats: array,
}
function StatsBar({ stats }) {
	return (
		<StatsBarWrapper>
			<FlexContainer>
				{stats.map((stat, i) => {
					return (
						<FlexRow key={`stat-${i}`}>
							<CheckMark height="54px" width="54px" />
							<Stat>{stat}</Stat>
						</FlexRow>
					)
				})}
			</FlexContainer>
		</StatsBarWrapper>
	)
}

export default StatsBar
